<div>
    <ul class="flex space-x-2 rtl:space-x-reverse">
        <li>
            <a href="javascript:;" class="text-primary hover:underline">Elements</a>
        </li>
        <li class="before:content-['/'] ltr:before:mr-2 rtl:before:ml-2">
            <span>Progress Bar</span>
        </li>
    </ul>
    <div class="grid grid-cols-1 gap-6 pt-5 lg:grid-cols-2">
        <div class="panel">
            <div class="mb-5 flex items-center justify-between">
                <h5 class="text-lg font-semibold dark:text-white-light">Basic</h5>
                <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code1')"
                    ><span class="flex items-center">
                        <icon-code class="me-2" />
                        Code
                    </span></a
                >
            </div>
            <div class="mb-5 space-y-5">
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-3/12 rounded-full bg-primary"></div>
                </div>
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-4/12 rounded-full bg-secondary"></div>
                </div>
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-5/12 rounded-full bg-success"></div>
                </div>
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-6/12 rounded-full bg-warning"></div>
                </div>
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-7/12 rounded-full bg-danger"></div>
                </div>
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-8/12 rounded-full bg-info"></div>
                </div>
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-9/12 rounded-full bg-black dark:bg-dark"></div>
                </div>
            </div>
            <ng-container *ngIf="codeArr.includes('code1')">
                <pre>
                    <code [languages]="['xml','typescript']" highlight="&lt;!-- primary --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-primary h-4 rounded-full w-3/12&quot;&gt;&lt;/div&gt;
&lt;/div&gt;

&lt;!-- secondary --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-secondary h-4 rounded-full w-4/12&quot;&gt;&lt;/div&gt;
&lt;/div&gt;

&lt;!-- success --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-success h-4 rounded-full w-5/12&quot;&gt;&lt;/div&gt;
&lt;/div&gt;

&lt;!-- warning --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-warning h-4 rounded-full w-6/12&quot;&gt;&lt;/div&gt;
&lt;/div&gt;

&lt;!-- danger --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-danger h-4 rounded-full w-7/12&quot;&gt;&lt;/div&gt;
&lt;/div&gt;

&lt;!-- info --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-info h-4 rounded-full w-8/12&quot;&gt;&lt;/div&gt;
&lt;/div&gt;

&lt;!-- black --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-black dark:bg-dark h-4 rounded-full w-9/12&quot;&gt;&lt;/div&gt;
&lt;/div&gt;
"></code>
                </pre>
            </ng-container>
        </div>

        <div class="panel">
            <div class="mb-5 flex items-center justify-between">
                <h5 class="text-lg font-semibold dark:text-white-light">Gradient</h5>
                <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code2')"
                    ><span class="flex items-center">
                        <icon-code class="me-2" />
                        Code
                    </span></a
                >
            </div>
            <div class="mb-5 space-y-5">
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-3/12 rounded-full bg-gradient-to-r from-[#0081ff] to-[#0045ff]"></div>
                </div>
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-4/12 rounded-full bg-gradient-to-r from-[#04befe] to-[#4481eb]"></div>
                </div>
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-5/12 rounded-full bg-gradient-to-r from-[#3cba92] to-[#0ba360]"></div>
                </div>
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-6/12 rounded-full bg-gradient-to-r from-[#f09819] to-[#ff5858]"></div>
                </div>
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-7/12 rounded-full bg-gradient-to-r from-[#d09693] to-[#c71d6f]"></div>
                </div>
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-8/12 rounded-full bg-gradient-to-r from-[#7579ff] to-[#b224ef]"></div>
                </div>
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-9/12 rounded-full bg-gradient-to-r from-[#2b5876] to-[#4e4376]"></div>
                </div>
            </div>
            <ng-container *ngIf="codeArr.includes('code2')">
                <pre>
                    <code [languages]="['xml','typescript']" highlight="&lt;!-- gradient primary --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-gradient-to-r from-[#0081ff] to-[#0045ff] h-4 rounded-full w-3/12&quot;&gt;&lt;/div&gt;
&lt;/div&gt;

&lt;!-- gradient info --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-gradient-to-r from-[#04befe] to-[#4481eb] h-4 rounded-full w-4/12&quot;&gt;&lt;/div&gt;
&lt;/div&gt;

&lt;!-- gradient success --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-gradient-to-r from-[#3cba92] to-[#0ba360] h-4 rounded-full w-5/12&quot;&gt;&lt;/div&gt;
&lt;/div&gt;

&lt;!-- gradient warning --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-gradient-to-r from-[#f09819] to-[#ff5858] h-4 rounded-full w-6/12&quot;&gt;&lt;/div&gt;
&lt;/div&gt;

&lt;!-- gradient danger --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-gradient-to-r from-[#d09693] to-[#c71d6f] h-4 rounded-full w-7/12&quot;&gt;&lt;/div&gt;
&lt;/div&gt;

&lt;!-- gradient secondary --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-gradient-to-r from-[#7579ff] to-[#b224ef] h-4 rounded-full w-8/12&quot;&gt;&lt;/div&gt;
&lt;/div&gt;

&lt;!-- gradient dark --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-gradient-to-r from-[#2b5876] to-[#4e4376] h-4 rounded-full w-9/12&quot;&gt;&lt;/div&gt;
&lt;/div&gt;
"></code>
                </pre>
            </ng-container>
        </div>

        <div class="panel">
            <div class="mb-5 flex items-center justify-between">
                <h5 class="text-lg font-semibold dark:text-white-light">Striped</h5>
                <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code3')"
                    ><span class="flex items-center">
                        <icon-code class="me-2" />
                        Code
                    </span></a
                >
            </div>
            <div class="mb-5 space-y-5">
                <div class="test h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div
                        class="striped-bar h-4 w-3/12 rounded-full bg-primary"
                        style="
                            background-image: linear-gradient(
                                45deg,
                                hsla(0, 0%, 100%, 0.15) 25%,
                                transparent 0,
                                transparent 50%,
                                hsla(0, 0%, 100%, 0.15) 0,
                                hsla(0, 0%, 100%, 0.15) 75%,
                                transparent 0,
                                transparent
                            );
                            background-size: 1rem 1rem;
                        "
                    ></div>
                </div>
            </div>
            <ng-container *ngIf="codeArr.includes('code3')">
                <pre>
                    <code [languages]="['xml','typescript']" highlight="&lt;!-- Striped --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-primary h-4 rounded-full w-3/12&quot; style=&quot;background-image: linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent); background-size: 1rem 1rem;&quot;&gt;&lt;/div&gt;
&lt;/div&gt;
"></code>
                </pre>
            </ng-container>
        </div>

        <div class="panel">
            <div class="mb-5 flex items-center justify-between">
                <h5 class="text-lg font-semibold dark:text-white-light">Animated</h5>
                <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code4')"
                    ><span class="flex items-center">
                        <icon-code class="me-2" />
                        Code
                    </span></a
                >
            </div>
            <div class="mb-5 space-y-5">
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div
                        class="animated-progress striped-bar h-4 w-6/12 rounded-full bg-primary"
                        style="
                            background-image: linear-gradient(
                                45deg,
                                hsla(0, 0%, 100%, 0.15) 25%,
                                transparent 0,
                                transparent 50%,
                                hsla(0, 0%, 100%, 0.15) 0,
                                hsla(0, 0%, 100%, 0.15) 75%,
                                transparent 0,
                                transparent
                            );
                            background-size: 1rem 1rem;
                        "
                    ></div>
                </div>
            </div>
            <ng-container *ngIf="codeArr.includes('code4')">
                <pre>
                    <code [languages]="['xml','typescript']" highlight="&lt;!-- animated --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-primary h-4 rounded-full w-6/12 animated-progress&quot; style=&quot;background-image: linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent); background-size: 1rem 1rem;&quot;&gt;&lt;/div&gt;
&lt;/div&gt;
"></code>
                </pre>
            </ng-container>
        </div>

        <div class="panel">
            <div class="mb-5 flex items-center justify-between">
                <h5 class="text-lg font-semibold dark:text-white-light">Labels</h5>
                <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code5')"
                    ><span class="flex items-center">
                        <icon-code class="me-2" />
                        Code
                    </span></a
                >
            </div>
            <div class="mb-5 space-y-5">
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="h-4 w-4/5 rounded-full bg-info text-center text-xs text-white">80%</div>
                </div>
                <div class="h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                    <div class="flex h-4 w-11/12 items-center justify-between rounded-full bg-danger px-2 text-center text-xs text-white">
                        <span>PHP</span><span>90%</span>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="codeArr.includes('code5')">
                <pre>
                    <code [languages]="['xml','typescript']" highlight="&lt;!-- labels --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-info h-4 rounded-full w-6/12 text-center text-white text-xs&quot;&gt;80%&lt;/div&gt;
&lt;/div&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full&quot;&gt;
    &lt;div class=&quot;bg-danger h-4 rounded-full w-8/12 text-center text-white flex justify-between items-center px-2 text-xs&quot;&gt;&lt;span&gt;PHP&lt;/span&gt;&lt;span&gt;90%&lt;/span&gt;&lt;/div&gt;
&lt;/div&gt;
"></code>
                </pre>
            </ng-container>
        </div>

        <div class="panel">
            <div class="mb-5 flex items-center justify-between">
                <h5 class="text-lg font-semibold dark:text-white-light">Stacked</h5>
                <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code6')"
                    ><span class="flex items-center">
                        <icon-code class="me-2" />
                        Code
                    </span>
                </a>
            </div>
            <div class="mb-5 space-y-5">
                <div class="space-y-2">
                    <h3 class="text-base">Basic</h3>
                    <div class="flex h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                        <div class="h-4 w-2/12 bg-success text-center text-xs text-white ltr:rounded-l-full rtl:rounded-r-full"></div>
                        <div class="h-4 w-4/12 bg-warning text-center text-xs text-white"></div>
                        <div class="h-4 w-3/12 bg-danger text-center text-xs text-white ltr:rounded-r-full rtl:rounded-l-full"></div>
                    </div>
                </div>
                <div class="space-y-2">
                    <h3 class="text-base">Striped</h3>
                    <div class="flex h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                        <div
                            class="striped-bar-sm h-4 w-2/12 bg-primary text-center text-xs text-white ltr:rounded-l-full rtl:rounded-r-full"
                            style="
                                background-image: linear-gradient(
                                    45deg,
                                    hsla(0, 0%, 100%, 0.15) 25%,
                                    transparent 0,
                                    transparent 50%,
                                    hsla(0, 0%, 100%, 0.15) 0,
                                    hsla(0, 0%, 100%, 0.15) 75%,
                                    transparent 0,
                                    transparent
                                );
                                background-size: 1rem 1rem;
                            "
                        ></div>
                        <div
                            class="striped-bar-sm h-4 w-4/12 bg-success text-center text-xs text-white"
                            style="
                                background-image: linear-gradient(
                                    45deg,
                                    hsla(0, 0%, 100%, 0.15) 25%,
                                    transparent 0,
                                    transparent 50%,
                                    hsla(0, 0%, 100%, 0.15) 0,
                                    hsla(0, 0%, 100%, 0.15) 75%,
                                    transparent 0,
                                    transparent
                                );
                                background-size: 1rem 1rem;
                            "
                        ></div>
                        <div
                            class="striped-bar-sm h-4 w-3/12 bg-info text-center text-xs text-white ltr:rounded-r-full rtl:rounded-l-full"
                            style="
                                background-image: linear-gradient(
                                    45deg,
                                    hsla(0, 0%, 100%, 0.15) 25%,
                                    transparent 0,
                                    transparent 50%,
                                    hsla(0, 0%, 100%, 0.15) 0,
                                    hsla(0, 0%, 100%, 0.15) 75%,
                                    transparent 0,
                                    transparent
                                );
                                background-size: 1rem 1rem;
                            "
                        ></div>
                    </div>
                </div>
                <div class="space-y-2">
                    <h3 class="text-base">Animated</h3>
                    <div class="flex h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                        <div
                            class="animated-progress striped-bar-sm h-4 w-2/12 bg-info text-center text-xs text-white ltr:rounded-l-full rtl:rounded-r-full"
                            style="
                                background-image: linear-gradient(
                                    45deg,
                                    hsla(0, 0%, 100%, 0.15) 25%,
                                    transparent 0,
                                    transparent 50%,
                                    hsla(0, 0%, 100%, 0.15) 0,
                                    hsla(0, 0%, 100%, 0.15) 75%,
                                    transparent 0,
                                    transparent
                                );
                                background-size: 1rem 1rem;
                            "
                        ></div>
                        <div
                            class="animated-progress striped-bar-sm h-4 w-4/12 bg-secondary text-center text-xs text-white"
                            style="
                                background-image: linear-gradient(
                                    45deg,
                                    hsla(0, 0%, 100%, 0.15) 25%,
                                    transparent 0,
                                    transparent 50%,
                                    hsla(0, 0%, 100%, 0.15) 0,
                                    hsla(0, 0%, 100%, 0.15) 75%,
                                    transparent 0,
                                    transparent
                                );
                                background-size: 1rem 1rem;
                            "
                        ></div>
                        <div
                            class="animated-progress striped-bar-sm h-4 w-3/12 bg-primary text-center text-xs text-white ltr:rounded-r-full rtl:rounded-l-full"
                            style="
                                background-image: linear-gradient(
                                    45deg,
                                    hsla(0, 0%, 100%, 0.15) 25%,
                                    transparent 0,
                                    transparent 50%,
                                    hsla(0, 0%, 100%, 0.15) 0,
                                    hsla(0, 0%, 100%, 0.15) 75%,
                                    transparent 0,
                                    transparent
                                );
                                background-size: 1rem 1rem;
                            "
                        ></div>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="codeArr.includes('code6')">
                <pre>
                    <code [languages]="['xml','typescript']" highlight="&lt;!-- basic --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full flex&quot;&gt;
    &lt;div class=&quot;bg-success h-4 ltr:rounded-l-full rtl:rounded-r-full w-2/12 text-center text-white text-xs&quot;&gt;&lt;/div&gt;
    &lt;div class=&quot;bg-warning h-4 w-4/12 text-center text-white text-xs&quot;&gt;&lt;/div&gt;
    &lt;div class=&quot;bg-danger h-4 ltr:rounded-r-full rtl:rounded-l-full w-3/12 text-center text-white text-xs&quot;&gt;&lt;/div&gt;
&lt;/div&gt;

&lt;!-- striped --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full flex&quot;&gt;
    &lt;div class=&quot;bg-primary h-4 ltr:rounded-l-full rtl:rounded-r-full w-2/12 text-center text-white text-xs&quot; style=&quot;background-image: linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent); background-size: 1rem 1rem;&quot;&gt;&lt;/div&gt;
    &lt;div class=&quot;bg-success h-4 w-4/12 text-center text-white text-xs&quot; style=&quot;background-image: linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent); background-size: 1rem 1rem;&quot;&gt;&lt;/div&gt;
    &lt;div class=&quot;bg-info h-4 ltr:rounded-r-full rtl:rounded-l-full w-3/12 text-center text-white text-xs&quot; style=&quot;background-image: linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent); background-size: 1rem 1rem;&quot;&gt;&lt;/div&gt;
&lt;/div&gt;

&lt;!-- animated --&gt;
&lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full flex&quot;&gt;
    &lt;div class=&quot;bg-info h-4 ltr:rounded-l-full rtl:rounded-r-full w-2/12 animated-progress text-center text-white text-xs&quot; style=&quot;background-image: linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent); background-size: 1rem 1rem;&quot;&gt;&lt;/div&gt;
    &lt;div class=&quot;bg-secondary h-4 w-4/12 animated-progress text-center text-white text-xs&quot; style=&quot;background-image: linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent); background-size: 1rem 1rem;&quot;&gt;&lt;/div&gt;
    &lt;div class=&quot;bg-primary h-4 ltr:rounded-r-full rtl:rounded-l-full w-3/12 animated-progress text-center text-white text-xs&quot; style=&quot;background-image: linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent); background-size: 1rem 1rem;&quot;&gt;&lt;/div&gt;
&lt;/div&gt;
"></code>
                </pre>
            </ng-container>
        </div>

        <div class="panel lg:row-span-2 lg:row-start-3">
            <div class="mb-5 flex items-center justify-between">
                <h5 class="text-lg font-semibold dark:text-white-light">Progress Bars Different Sizes</h5>
                <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code7')"
                    ><span class="flex items-center">
                        <icon-code class="me-2" />
                        Code
                    </span></a
                >
            </div>
            <div class="mb-5 space-y-5">
                <div class="space-y-1">
                    <h3 class="text-primary">Default Progress Bar Size</h3>
                    <div class="flex h-4 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                        <div class="h-4 w-3/12 rounded-full rounded-bl-full bg-primary text-center text-xs text-white"></div>
                    </div>
                </div>
                <div class="space-y-2">
                    <h3 class="text-base text-success">Progress-sm</h3>
                    <div class="flex h-1 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                        <div class="h-1 w-5/12 rounded-full rounded-bl-full bg-success text-center text-xs text-white"></div>
                    </div>
                </div>
                <div class="space-y-2">
                    <h3 class="text-base text-warning">Progress-md</h3>
                    <div class="flex h-2.5 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                        <div class="h-2.5 w-7/12 rounded-full rounded-bl-full bg-warning text-center text-xs text-white"></div>
                    </div>
                </div>
                <div class="space-y-2">
                    <h3 class="text-base text-info">Progress-lg</h3>
                    <div class="flex h-5 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                        <div class="h-5 w-8/12 rounded-full rounded-bl-full bg-info text-center text-xs text-white"></div>
                    </div>
                </div>
                <div class="space-y-2">
                    <h3 class="text-base text-danger">Progress-xl</h3>
                    <div class="flex h-6 w-full rounded-full bg-[#ebedf2] dark:bg-dark/40">
                        <div class="h-6 w-10/12 rounded-full rounded-bl-full bg-danger text-center text-xs text-white"></div>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="codeArr.includes('code7')">
                <pre>
                    <code [languages]="['xml','typescript']" highlight="&lt;!-- default --&gt;
&lt;div class=&quot;space-y-1&quot;&gt;
    &lt;h3 class=&quot;text-primary&quot;&gt;Default Progress Bar Size&lt;/h3&gt;
    &lt;div class=&quot;w-full h-4 bg-[#ebedf2] dark:bg-dark/40 rounded-full flex&quot;&gt;
        &lt;div class=&quot;bg-primary h-4 rounded-full rounded-bl-full w-3/12 text-center text-white text-xs&quot;&gt;&lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;

&lt;!-- small --&gt;
&lt;div class=&quot;space-y-2&quot;&gt;
    &lt;h3 class=&quot;text-base text-success&quot;&gt;Progress-sm&lt;/h3&gt;
    &lt;div class=&quot;w-full h-1 bg-[#ebedf2] dark:bg-dark/40 rounded-full flex&quot;&gt;
        &lt;div class=&quot;bg-success h-1 rounded-full rounded-bl-full w-5/12 text-center text-white text-xs&quot;&gt;&lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;

&lt;!-- medium --&gt;
&lt;div class=&quot;space-y-2&quot;&gt;
    &lt;h3 class=&quot;text-base text-warning&quot;&gt;Progress-md&lt;/h3&gt;
    &lt;div class=&quot;w-full h-2.5 bg-[#ebedf2] dark:bg-dark/40 rounded-full flex&quot;&gt;
        &lt;div class=&quot;bg-warning h-2.5 rounded-full rounded-bl-full w-7/12 text-center text-white text-xs&quot;&gt;&lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;

&lt;!-- large --&gt;
&lt;div class=&quot;space-y-2&quot;&gt;
    &lt;h3 class=&quot;text-base text-info&quot;&gt;Progress-lg&lt;/h3&gt;
    &lt;div class=&quot;w-full h-5 bg-[#ebedf2] dark:bg-dark/40 rounded-full flex&quot;&gt;
        &lt;div class=&quot;bg-info h-5 rounded-full rounded-bl-full w-8/12 text-center text-white text-xs&quot;&gt;&lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;

&lt;!-- extra large --&gt;
&lt;div class=&quot;space-y-2&quot;&gt;
    &lt;h3 class=&quot;text-base text-danger&quot;&gt;Progress-xl&lt;/h3&gt;
    &lt;div class=&quot;w-full h-6 bg-[#ebedf2] dark:bg-dark/40 rounded-full flex&quot;&gt;
        &lt;div class=&quot;bg-danger h-6 rounded-full rounded-bl-full w-10/12 text-center text-white text-xs&quot;&gt;&lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;
"></code>
                </pre>
            </ng-container>
        </div>
    </div>
</div>
